import { IframeUtility } from '@inter-ikea-kompis/utilities';
/**
 * This class handles communication with the ROIG application through post message.
 */
export default class RoigPlatformCommunication {
    /**
     * Sets the iframe container height.
     *
     * @param height Height to set.
     */
    setIframeHeight(height) {
        if (IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                method: 'setHeight',
                parameters: {
                    height
                }
            }, '*');
        }
    }
    /**
     * Adds items to shopping bag.
     *
     * @param items List of items.
     * @param vpcCode VPC code.
     */
    addToCart(items, vpcCode) {
        if (IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                method: 'addToShoppingBag',
                parameters: {
                    items: items.map((item) => {
                        return { ID: item.id, Type: item.type, Qty: item.quantity };
                    }),
                    vpcCode
                }
            }, '*');
        }
    }
    /**
     * Sets the cart count.
     *
     * @param cartCount Cart count to set.
     */
    setCartCount(cartCount) {
        if (IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                method: 'setCartCount',
                parameters: {
                    cartCount: cartCount
                }
            }, '*');
        }
    }
}
//# sourceMappingURL=RoigPlatformCommunication.js.map